// src/features/authSlice.js

import { createSlice, createAction } from '@reduxjs/toolkit';
import { clearAllCache } from '../utils/userCache';

// Create a logout action
export const logout = createAction('auth/logout');

const initialState = {
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken(state, action) {
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('token', action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('token');
      // Clear all cached user/units data for security
      clearAllCache();
    });
  },
});

export const { setAuthToken } = authSlice.actions;

// Selector to get authentication status
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

// Selector to get the token
export const selectAuthToken = (state) => state.auth.token;

export default authSlice.reducer;
